<template>
    <div>
        <el-dialog title="消息提示" :visible.sync="shareDialogVisible" width="30%">
            <span>确定要取消收藏吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show(1)">取 消</el-button>
                <el-button type="primary" @click="show(2)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>  
export default {
  props:{
    pushlog:{        
      default: false
    }
  },
  components: {},
  data() {
    return {
      shareDialogVisible:false,
    };
  },
  watch:{
    pushlog(oldVal,newVal){
      this.shareDialogVisible = this.pushlog
    },
  },
  mounted(){
  },
  methods:{
    show(e){
      var that=this
      if(e == 1){
        that.shareDialogVisible =false
        this.$emit('renoav', e)
      } else if(e == 2){
        that.shareDialogVisible =false
        this.$emit('renoav', e)
      }
    }, 
  } 
};
</script>

<style lang="less" scoped>
</style>
